import React from 'react'

export const AccessGroupTableContext = React.createContext<boolean>(true)
